module.exports = __webpack_public_path__ + "img/splash.cecd443e.svg";